
import { firebaseMutations, firebaseAction } from 'vuexfire'

const state = {
  todos: [],
  tasks: []
}

const mutations = firebaseMutations;

const getters = {
  tasks: state => state.tasks,
  todos: state => state.todos
}

const actions = {
  setTodosRef: firebaseAction(({bindFirebaseRef}, {ref, limit}) => {
    bindFirebaseRef('todos', ref.limitToLast(limit))
  }),
  setTasksRef: firebaseAction(({bindFirebaseRef}, {ref, limit}) => {
    bindFirebaseRef('tasks', ref.limitToLast(limit))
  })
}

export default {
  state,
  actions,
  mutations,
  getters
}
